import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';

import { getOrgLocations, createLocation } from '../../actions/locations';

import LocationFormOverlay from '../../components/locations/LocationFormOverlay';


class LocationCreatePopup extends React.Component<any, any> {
  onSubmit = (data) => {
    const { dispatch, orgId } = this.props;

    return dispatch(createLocation(orgId, data))
      .then(() => {
        // TODO: Use refresh
        dispatch(getOrgLocations(orgId));
        this.props.onReturn();
      });
  }

  onClose = () => {
    this.props.onReturn();
  }

  render() {
    return (
      <LocationFormOverlay
        headTitle="New Location"
        onSubmit={this.onSubmit}
        onClose={this.onClose}
      />
    );
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(null, mapDispatchToProps)(LocationCreatePopup) as any;
